import AuthCli from './AuthCli'

/**
 * JavaScript version of the Config service API.
 */
export default class ConfigCli {

  //
  // Path constants:
  //
  static get SERVICE_ROUTE() { return 'config' }
  static get SYSTEM_INFO() { return 'systeminfo' }

  // URL prefix for debugging environment vs behind reverse proxy environment.
  static get devPrefix() { return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'http://localhost:6002/' : window.location.protocol + '//' + window.location.host + '/api/' }
  
  /**
   * Provides information about the system like software version details.
   */
  static async GetSystemInfo() {
    var verb = 'GET'
    var path = this.SERVICE_ROUTE + '/' + this.SYSTEM_INFO
    var body = null

    console.debug('ConfigCli.GetSystemInfo: ' + this.devPrefix + path)
  
    return AuthCli.Fetch(this.devPrefix + path, verb, body)
  }
}


// WEBPACK FOOTER //
// ./src/sdk/ConfigCli.js